import { ProcedureStoreTagTypes } from './procedure.type'

type SaveSoapNoteInvalidationArgs = {
  isFirstSave?: boolean
  skipESignInvalidation?: boolean
}

// Later saves are patched into the cache; only the first save needs the note's labels/templates.
export const getSaveSoapNoteInvalidatedTags = (
  error: unknown,
  { isFirstSave = false, skipESignInvalidation = false }: SaveSoapNoteInvalidationArgs,
): ProcedureStoreTagTypes[] => {
  if (error) {
    return []
  }

  return [
    ...(isFirstSave ? [ProcedureStoreTagTypes.SoapNotes] : []),
    ...(skipESignInvalidation ? [] : [ProcedureStoreTagTypes.ESignForm]),
  ]
}
